<div class="px-2 sm:px-4 md:px-8 py-6">

  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">account_balance</mat-icon>
      R4 Conecta Dashboard
      <span style="font-size: 0.8rem; color: #6b7280; font-weight: 500; margin-left: 8px;">(Mi Banco)</span>
    </h1>
    <div class="flex items-center gap-2 flex-wrap">
      <!-- Health: conectividad con el banco (ping MBbcv) -->
      <span *ngIf="!healthLoading" class="px-3 py-1 rounded-full text-xs font-bold inline-flex items-center gap-1.5"
        [style.background]="health?.operational ? '#f0fdf4' : '#fef2f2'"
        [style.color]="health?.operational ? '#15803d' : '#b91c1c'"
        [style.border]="health?.operational ? '1px solid #bbf7d0' : '1px solid #fecaca'"
        [matTooltip]="health?.operational ? ('Tasa BCV: ' + (health?.tasaBcv || '-')) : (health?.error || 'Sin conexión')">
        <span class="health-dot" [class.dot-ok]="health?.operational" [class.dot-down]="!health?.operational"></span>
        {{ health?.operational ? 'Operacional' : 'Caído' }}
      </span>
      <mat-spinner *ngIf="healthLoading" diameter="20"></mat-spinner>

      <span class="px-3 py-1 rounded-full text-xs font-bold inline-flex items-center gap-1.5"
        [style.background]="pagoR4Activo ? '#f0fdf4' : '#f3f4f6'"
        [style.color]="pagoR4Activo ? '#15803d' : '#6b7280'"
        [style.border]="pagoR4Activo ? '1px solid #bbf7d0' : '1px solid #e5e7eb'">
        <span class="health-dot" [class.dot-ok]="pagoR4Activo" [class.dot-down]="!pagoR4Activo"></span>
        {{ pagoR4Activo ? 'Pagos activos' : 'Pagos inactivos' }}
      </span>

      <button type="button" (click)="openRegistrarOperadorModal()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">post_add</mat-icon>
        Registrar referencia
      </button>

      <button type="button" (click)="openMontoModal()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: white; color: #1C593D; border: 1px solid #1C593D; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">tune</mat-icon>
        Montos
      </button>

      <button type="button" (click)="toggle()" [disabled]="loadingToggle"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        [style.background]="pagoR4Activo ? '#fef2f2' : '#f0fdf4'"
        [style.color]="pagoR4Activo ? '#b91c1c' : '#15803d'"
        [style.border]="pagoR4Activo ? '1px solid #fecaca' : '1px solid #bbf7d0'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;">{{ pagoR4Activo ? 'toggle_off' : 'toggle_on' }}</mat-icon>
        {{ pagoR4Activo ? 'Desactivar pagos' : 'Activar pagos' }}
      </button>

      <button type="button" (click)="loadAll()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;">refresh</mat-icon>
        Refrescar
      </button>
    </div>
  </div>

  <!-- KPIs -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-5">
    <div style="background: linear-gradient(135deg, #fef3c7, #fde68a); padding: 14px 18px; border-bottom: 2px solid #fcd34d;" class="flex items-center gap-2">
      <mat-icon style="color: #b45309; font-size: 20px; width: 20px; height: 20px;">insights</mat-icon>
      <span style="font-size: 0.85rem; font-weight: 700; color: #78350f;">Operaciones R4</span>
    </div>
    <div class="p-4 grid grid-cols-2 sm:grid-cols-5 gap-3" *ngIf="stats">
      <div style="background:#f3f4f6; border-radius:10px; padding:10px; text-align:center;">
        <div style="font-size:0.62rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Total</div>
        <div style="font-size:1.05rem; font-weight:800; color:#374151;">{{ stats.total }}</div>
      </div>
      <div style="background:#f0fdf4; border-radius:10px; padding:10px; text-align:center;">
        <div style="font-size:0.62rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Completadas</div>
        <div style="font-size:1.05rem; font-weight:800; color:#15803d;">{{ stats.completed }}</div>
      </div>
      <div style="background:#fef9c3; border-radius:10px; padding:10px; text-align:center;">
        <div style="font-size:0.62rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Pendientes</div>
        <div style="font-size:1.05rem; font-weight:800; color:#a16207;">{{ stats.pending }}</div>
      </div>
      <div style="background:#fef2f2; border-radius:10px; padding:10px; text-align:center;">
        <div style="font-size:0.62rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Rechazadas</div>
        <div style="font-size:1.05rem; font-weight:800; color:#dc2626;">{{ stats.rejected }}</div>
      </div>
      <div style="background:#fff7ed; border-radius:10px; padding:10px; text-align:center;">
        <div style="font-size:0.62rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Error / Timeout</div>
        <div style="font-size:1.05rem; font-weight:800; color:#c2410c;">{{ stats.error + stats.timeout }}</div>
      </div>
    </div>
  </div>

  <!-- Montos contractuales -->
  <div class="bg-white rounded-xl shadow-md border border-gray-100 mb-5 overflow-hidden" *ngIf="monto">
    <div style="background: #f0f9ff; padding: 12px 16px; border-bottom: 1px solid #bae6fd; display: flex; align-items: center; gap: 8px;">
      <mat-icon style="color: #0369a1; font-size: 20px; width: 20px; height: 20px;">trending_up</mat-icon>
      <span style="font-size: 0.85rem; font-weight: 700; color: #0c4a6e;">Límites por operación</span>
    </div>
    <div class="p-4 flex flex-wrap gap-6">
      <div>
        <div style="font-size:0.68rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Tope operativo (R4_MONTO_MIN)</div>
        <div style="font-size:1.2rem; font-weight:800; color:#0c4a6e;">{{ formatVES(monto.montoMin) }}</div>
      </div>
      <div>
        <div style="font-size:0.68rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Tope duro banco (R4_MONTO_MAX)</div>
        <div style="font-size:1.2rem; font-weight:800; color:#374151;">{{ formatVES(monto.montoMax) }}</div>
      </div>
    </div>
  </div>

  <!-- Tabla de operaciones -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 18px; border-bottom: 2px solid #bbf7d0;" class="flex items-center gap-2 flex-wrap">
      <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">receipt_long</mat-icon>
      <span style="font-size: 0.85rem; font-weight: 700; color: #374151;">Operaciones</span>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="ml-auto" style="font-size: 0.78rem; width: 180px;">
        <mat-label>Estado</mat-label>
        <mat-select [(value)]="filterStatus" (selectionChange)="loadOperations()">
          <mat-option *ngFor="let s of statusOptions" [value]="s">{{ s || 'Todos' }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div style="overflow-x: auto;">
      <table style="width: 100%; border-collapse: collapse; font-size: 0.78rem;">
        <thead>
          <tr style="background: #f9fafb; text-align: left; color: #6b7280;">
            <th style="padding: 10px 12px; font-weight: 600;">Tipo</th>
            <th style="padding: 10px 12px; font-weight: 600;">Estado</th>
            <th style="padding: 10px 12px; font-weight: 600;">Referencia</th>
            <th style="padding: 10px 12px; font-weight: 600; text-align: right;">Monto</th>
            <th style="padding: 10px 12px; font-weight: 600;">Cédula</th>
            <th style="padding: 10px 12px; font-weight: 600;">Creada</th>
            <th style="padding: 10px 12px; font-weight: 600; text-align: center;">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let op of operations" style="border-top: 1px solid #f1f5f9;">
            <td style="padding: 10px 12px; color: #374151;">{{ op.operationType }}</td>
            <td style="padding: 10px 12px;">
              <span class="px-2 py-0.5 rounded-full text-xs font-bold" style="color: white;" [style.background]="statusColor(op.status)">
                {{ op.status }}
              </span>
            </td>
            <td style="padding: 10px 12px; font-family: monospace; color: #374151;">{{ op.referencia }}</td>
            <td style="padding: 10px 12px; text-align: right; font-weight: 600; color: #1f2937;">{{ formatVES(op.monto) }}</td>
            <td style="padding: 10px 12px; color: #6b7280;">{{ op.cedula || '-' }}</td>
            <td style="padding: 10px 12px; color: #6b7280;">{{ op.createdAt | date:'dd/MM/yy HH:mm' }}</td>
            <td style="padding: 10px 12px; white-space: nowrap; text-align: center;">
              <button mat-icon-button (click)="openDetail(op)" matTooltip="Ver detalle">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6366f1;">visibility</mat-icon>
              </button>
              <button mat-icon-button (click)="pollOperation(op)" matTooltip="Validar estado contra el banco (ConsultarOperaciones)">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #0369a1;">sync</mat-icon>
              </button>
            </td>
          </tr>
          <tr *ngIf="!loading && operations.length === 0">
            <td colspan="7" style="padding: 28px; text-align: center; color: #9ca3af;">Sin operaciones</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="loading" class="flex justify-center py-5">
      <mat-spinner diameter="28"></mat-spinner>
    </div>
  </div>

  <!-- Error -->
  <div *ngIf="error" style="display: flex; align-items: center; gap: 8px; background: #fef2f2; padding: 12px 16px; border-radius: 10px; border: 1px solid #fecaca; margin-top: 16px;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626;">warning</mat-icon>
    <span style="font-size: 0.85rem; font-weight: 600; color: #b91c1c;">{{ error }}</span>
  </div>
</div>
